var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"saved-alert",attrs:{"type":"success","text":_vm.isTextStyle,"transition":"fade-transition","value":_vm.value}},[_vm._v(_vm._s(_vm.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }